/** Класс настроек системы */
export class AppSettings {
    /** Руководства по системе */
    public guides: { userGuides: guide[]; videoInstructions: guide[] } = {
        userGuides: [],
        videoInstructions: [],
    };
    /** Флаг отображения фильтров на страницу списка реестров */
    public readonly showFactorInputFilter: boolean = false;

    /** ID рубрикатора, который определяет категории реестров */
    public readonly categoriesRegistry: number = 0;

    constructor(data: any) {
        this._setGuides(data?.guides);

        this.showFactorInputFilter = data.hasOwnProperty('showFactorInputFilter') && data.showFactorInputFilter;

        if (data.hasOwnProperty('categories_registry')) {
            this.categoriesRegistry = Number(data.categories_registry?.value);
        }
    }

    /**
     * Установка руководств пользователей
     * @param guides - объект руководств
     * @private
     */
    private _setGuides(guides: { userguides?: []; videoinstructions?: [] }) {
        this.guides.userGuides = guides?.userguides ?? [];
        this.guides.videoInstructions = guides?.videoinstructions ?? [];
    }
}

/** Тип руководство */
type guide = { name: string; url: string };
